import { parseISO, format } from "date-fns";
import { get, isEmpty, uniq } from "lodash";
import { trackingStatuses } from "./constants";
import { formatInTimeZone } from 'date-fns-tz';

export const getTrackBarcodesParams = (barcodes = []) => {
  const barcode = barcodes.reduce((acc, curr) => (acc += `,${curr}`));

  return {
    params: {
      barcodes: barcode,
    },
  };
};

export const getTrackingStatus = (status) => {
  if (trackingStatuses.map(({ name }) => name).includes(status)) {
    return trackingStatuses.find(({ name }) => name === status).label;
  }

  return "Unknown";
};

export const getAddress = (info) => {
  return `${get(info, "packagedetails.toaddressline1", "------")} ${get(
    info,
    "packagedetails.toaddressline2",
    ""
  )} ${get(info, "packagedetails.tocity", "")}, ${get(
    info,
    "packagedetails.tostate",
    "------"
  )} ${get(info, "packagedetails.tozipcode", "")}`;
};

export const getDeliveryDate = (date) => {
  if (date !== undefined && !isEmpty(date)) {
    return formatInTimeZone(parseISO(date), "America/Chicago", "MM/dd/yyyy hh:mm a"); //format(parseISO(date), "MM/dd/yyyy hh:mm a", {timeZone: 'CST'});
  }

  return "";
};

export const cleanTrackingCodes = (barcodes = []) => {
  // eslint-disable-next-line array-callback-return
  const cleanedBarcodes = barcodes.filter((barcode) => {
    if (!isEmpty(barcode)) {
      return barcode;
    }
  });
  return uniq(cleanedBarcodes);
};

export const getProofOfDeliveryParams = (barcode = "", user = {}) => {

  return {
    params: {
      cust_id: user.account_number,
      uid: user.user_id,
      login_name: user.login_name,
      air_bill_number: barcode,
    },
  };
};
